import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

// components
import SideBar from './SideBar/SideBar';

import { colors } from '../constants/colors';
import styles from './Layout.module.css';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', position: 'relative' }}>
      <button
        type="button"
        aria-label={sidebarOpen ? 'Закрыть меню' : 'Открыть меню'}
        className={`${styles.burger} ${sidebarOpen ? styles.burgerHidden : ''}`}
        onClick={() => setSidebarOpen((prev) => !prev)}
      >
        {sidebarOpen ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        )}
      </button>
      <SideBar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div
        className={`main-content ${styles.mainContent}`}
        style={{
          width: '100%',
          maxHeight: '100vh',
          overflowY: 'auto',
          overflowX: 'auto',
          backgroundColor: colors.backgroung,
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
